// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__280NN","productName":"Table_productName__27hcM"};